export default __webpack_public_path__ + "ce30662428543690d1b21ce2da17c39e.png";